import { useContext } from "react";
import DatePicker from "react-datepicker";
import { TicketContext } from "../../../helpers/context";


const DateStart = () => {

  
  
  const [newTicket, setNewTicket] = useContext(TicketContext)

  return (
    <DatePicker
      dateFormat="dd.MM.yyyy"
      showIcon
      selected={newTicket.dateStart}
      onChange={(date) => setNewTicket({...newTicket, dateStart: date})}
      className="input input_start"
      icon={
        <svg
          width="20"
          height="23"
          viewBox="0 0 20 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.4608 2.1545C14.4608 1.41302 14.4608 0.727494 14.4608 0C15.1971 0 15.8778 0 16.6418 0C16.6418 0.713503 16.6418 1.41302 16.6418 2.21046C17.0724 2.21046 17.4475 2.19647 17.8086 2.21046C19.0311 2.25243 19.9896 3.1618 19.9896 4.39294C20.0035 9.66727 20.0035 14.9276 19.9896 20.2019C19.9896 21.3911 19.0311 22.3424 17.8503 22.3424C12.6133 22.3564 7.39017 22.3564 2.15315 22.3424C0.930717 22.3424 0.0138913 21.3771 0 20.132C0 14.9136 0 9.68126 0.0138913 4.46289C0.0138913 3.14781 0.9585 2.23844 2.26428 2.21046C2.58378 2.19647 2.90328 2.21046 3.30613 2.21046C3.30613 1.46898 3.30613 0.769464 3.30613 0.0139903C4.08404 0.0139903 4.77861 0.0139903 5.54263 0.0139903C5.54263 0.727494 5.54263 1.41302 5.54263 2.1545C8.51537 2.1545 11.4325 2.1545 14.4608 2.1545ZM2.27817 7.82056C2.27817 11.9057 2.27817 15.9769 2.27817 20.062C7.44574 20.062 12.5855 20.062 17.7253 20.062C17.7253 15.9489 17.7253 11.8917 17.7253 7.82056C12.5577 7.82056 7.44574 7.82056 2.27817 7.82056Z"
            fill="#E5E5E5"
          />
          <path
            d="M10.0295 17.8096C10.0295 15.9769 10.0295 14.1721 10.0295 12.3114C11.8632 12.3114 13.6691 12.3114 15.5166 12.3114C15.5166 14.1302 15.5166 15.9489 15.5166 17.8096C13.7246 17.8096 11.9188 17.8096 10.0295 17.8096Z"
            fill="#E5E5E5"
          />
        </svg>
      }
    />
  );
};

export default DateStart;
